import { cn } from "@/lib/utils";
import { textStyles } from "@/lib/design-system/components";
import { HTMLAttributes } from "react";

interface TextProps extends HTMLAttributes<HTMLParagraphElement> {
  size?: "xs" | "sm" | "base" | "lg" | "xl";
  weight?: "normal" | "medium" | "semibold" | "bold";
}

export const Text = ({
  size,
  weight,
  className,
  children,
  ...props
}: TextProps) => {
  return (
    <p
      className={cn(textStyles({ size, weight }), className)}
      {...props}
    >
      {children}
    </p>
  );
};